// @ts-nocheck
import { ReactElement, useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Lottie from 'react-lottie'
import useSWRInfinite from 'swr/infinite'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useAuth } from '../../hooks/auth'
import { LOCAL_EXECUTION } from '../../utils/featureFlag'
import * as notFoundAnimation from '../../assets/error-notfound.json'
import {
  Container,
  FormDivider,
  PageSubtitle,
  PageTitle,
  TextHeaderBox,
  DateManager,
  SelectDateContainer,
  SelectDateText,
  EventCard,
  ImgEvent,
  DividerH,
  CardTitle,
  CardDescription,
  CardContent,
  CardButton,
  ErrorBox,
  ExceptionContainer,
  ShowEventButton,
  InputContainer,
} from './styles'
import Loader from '../../components/Loader'
import { DashboardInput } from 'bd-web-components'
import { useEvents } from '../../hooks/events'
import { parseISO, format, setDefaultOptions } from 'date-fns'
import pt from 'date-fns/locale/pt-BR'
import noImage from '../../assets/no-image-1970x700.png'
import MaisShowBanner from '../../components/MaisShowBanner'

export function Events(): ReactElement {
  window.document.title = 'Lista de eventos'
  const authContext = useAuth()
  const navigate = useNavigate()
  const { authHookWithOutEvent } = authContext

  const [tab, setTab] = useState<string>('next')
  const [lastPage, setLastPage] = useState<boolean>(false)
  const [name, setName] = useState<string>('')

  const getKey = (pageIndex: any, previousPageData: any) => {
    let future = tab === 'next' ? 1 : 0

    return `producer/analytics/events?page=${pageIndex + 1
      }&future=${future}&name=${name}`
  }

  const { data, isLoading, isValidating, size, setSize }: any = useSWRInfinite(
    getKey,
    useEvents,
    {
      initialSize: 1,
      revalidateAll: false,
      revalidateIfStale: false,
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      revalidateFirstPage: false,
    }
  )

  setDefaultOptions({ locale: pt })

  // AUTH SECTION
  if (!LOCAL_EXECUTION) {
    authHookWithOutEvent()
  }

  const changeTab = (value: string) => {
    setSize(1)
    setTab(value)
  }

  useEffect(() => {
    data?.length && setLastPage(data.at(-1).data.last_page)
  }, [data])

  const getEventImage = (event: any) => {
    let image: string = noImage
    let resolution: number = 0

    event?.imagens?.map((value: any) => {
      if (value.resolution > resolution) {
        image = value.url
        resolution = value.resolution
      }

      return value
    })

    return image
  }

  return (
    <>
      <Container>
        <TextHeaderBox>
          <PageTitle>{'Eventos'}</PageTitle>
          <PageSubtitle>
            {
              'Visualize todos os seus eventos. Clique em ver evento para saber todas as informações.'
            }
          </PageSubtitle>
        </TextHeaderBox>
        <FormDivider />

        <MaisShowBanner />

        <DateManager>
          <SelectDateContainer>
            <SelectDateText
              onClick={() => changeTab('next')}
              className={tab === 'next' ? 'active' : ''}
            >
              Próximos Eventos
            </SelectDateText>
            <SelectDateText
              onClick={() => changeTab('past')}
              className={tab === 'past' ? 'active' : ''}
            >
              Eventos Passados
            </SelectDateText>
          </SelectDateContainer>
          <InputContainer>
            <DashboardInput
              type={'input'}
              name={'searchName'}
              placeholder={'Buscar evento'}
              onChange={(e: any) => {
                setName(e.target.value)
              }}
            />
          </InputContainer>
        </DateManager>

        <InfiniteScroll
          dataLength={data?.length ?? 0}
          next={() => setSize(size + 1)}
          hasMore={!lastPage}
          loader={<></>}
          endMessage={
            isValidating === false &&
            isLoading === false && (
              <p style={{ textAlign: 'center' }}>
                <b>Por hora é só!</b>
              </p>
            )
          }
        >
          {data?.map((datas: any) => (
            <>
              {datas.data?.data?.map((event: any) => (
                <EventCard>
                  <ImgEvent
                    src={getEventImage(event)}
                    onError={({ currentTarget }) => {
                      currentTarget.onerror = null
                      currentTarget.src = noImage
                    }}
                  />
                  <CardContent>
                    <CardTitle>{event.nome}</CardTitle>
                    <CardDescription>
                      {event?.start_at &&
                        `Evento em ${format(
                          parseISO(event?.start_at),
                          "dd 'de' MMMM, yyyy"
                        )}`}
                      <DividerH />
                      {event.cliente}
                    </CardDescription>
                  </CardContent>
                  <CardButton>
                    <ShowEventButton
                      onClick={() => navigate(`${event.id}`)}
                      height="48px"
                      maxWidth="100%"
                    >
                      {'VER EVENTO'}
                    </ShowEventButton>
                  </CardButton>
                </EventCard>
              ))}
            </>
          ))}
        </InfiniteScroll>

        {isValidating === false && isLoading === false && data?.length === 0 && (
          <>
            <EventCard className="error">
              <ErrorBox>
                <Lottie
                  options={{
                    loop: false,
                    autoplay: true,
                    animationData: notFoundAnimation,
                    rendererSettings: {
                      preserveAspectRatio: 'xMidYMid slice',
                    },
                  }}
                  isStopped={false}
                  isPaused={false}
                />
              </ErrorBox>
              <CardContent>
                <CardTitle className="error">
                  {'Nenhum evento foi encontrado '}
                </CardTitle>
                <CardDescription className="error">
                  Caso esteja com algum erro, entre em contato com o comercial.
                </CardDescription>
              </CardContent>
            </EventCard>
          </>
        )}

        {(isValidating === true || isLoading === true) && (
          <ExceptionContainer height={100} margin={false}>
            <Loader />
          </ExceptionContainer>
        )}
      </Container>
    </>
  )
}
